import * as React from 'react';

import CollapsibleSimple from 'components/collapsible/simple/CollapsibleSimple';

import DiscoveryCreatorsFilterPopover from 'modules/freemium/components/discovery-creators-filter-popover/DiscoveryCreatorsFilterPopover';
import CreateNewProfilesButton from 'modules/create-new-profiles/components/create-new-profiles-button/CreateNewProfilesButton';

import { __t, applyTranslations } from 'utils/language';

import './discovery-creators-filters-add-lightweight.scss';

applyTranslations(require('./discovery-creators-filters-add-lightweight.i18n.json'));

type Props = {
  isFreemium: boolean
};

const msgKey = 'discovery_creators_filters_add_lightweight';

const DiscoveryCreatorsFiltersAddLightweight = ({
  isFreemium
}: Props): React.ReactNode => {
  const renderButtonPopover = (children: React.ReactNode): JSX.Element => (
    <DiscoveryCreatorsFilterPopover
      triggerComponent={children}
    />
  );

  const renderButton = (): React.ReactNode => (
    <CreateNewProfilesButton openedOn="discovery" />
  );

  const renderContents = (): React.ReactNode => (
    <div className="discovery-creators-filters-add-lightweight__content">
      <div className="discovery-creators-filters-add-lightweight__message">
        {__t(`${msgKey}.messages.create_profile`)}
      </div>
      {
        isFreemium
          ? renderButtonPopover(renderButton())
          : renderButton()
      }
    </div>
  );

  return (
    <div className="discovery-creators-filters-add-lightweight">
      <CollapsibleSimple
        title={__t(`${msgKey}.labels.add_creator`)}
        isExpanded
      >
        {renderContents()}
      </CollapsibleSimple>
    </div>
  );
};

export default DiscoveryCreatorsFiltersAddLightweight;
